import './MobileMenu.scss';
class MobileMenu {
    constructor( node ) {
        this.node = node;
    }
    init() {
        
        let t = this;
        let hamburger = document.getElementById('hamburger');
        let buttons = t.node.querySelectorAll('.item__button[data-id]');
        let basicNav = t.node.querySelector('.wrapper__content .content__basic');
        let subNavs = t.node.querySelectorAll('.wrapper__content .content__nav');

        hamburger.addEventListener('click', ( event ) => {
            if( hamburger.classList.contains('active') ) {
                t.node.classList.add('active');
                document.body.classList.add('disableScrollMobileMenu');
            } else {
                t.node.classList.remove('active');
                document.body.classList.remove('disableScrollMobileMenu');
                t.resetNavs();
            }
        });
        document.addEventListener('keydown', ( event ) => {
            if( event.code && event.code.toLowerCase() == 'escape' && t.node.classList.contains('active') ) {
                t.node.classList.remove('active');
                document.body.classList.remove('disableScrollMobileMenu');
                t.resetNavs();
                if( window.innerWidth <= 960 ) {
                    hamburger.classList.remove('active');
                }
            }
        });

        document.addEventListener('click', ( event ) => {
            if(  t.node.classList.contains('active') && !event.target.closest('.MobileMenu__wrapper') && !event.target.classList.contains('Hamburger') ) {
                t.node.classList.remove('active');
                // document.querySelector('header .Header__nav').classList.remove('active');
                document.body.classList.remove('disableScrollMobileMenu');
                t.resetNavs();
                if( window.innerWidth <= 960 ) {
                    hamburger.classList.remove('active');
                }
            }
        });
        buttons.forEach( ( button, index ) => {
            button.addEventListener( 'click', () => {
                subNavs.forEach( ( nav, index ) => {
                    if( nav.getAttribute('data-id') != button.getAttribute('data-id') ) {
                        nav.classList.remove('active');
                    } else {
                        basicNav.classList.remove('active');
                        nav.classList.add('active');
                    }
                });
            });
        });

        subNavs.forEach( ( nav, index ) => {
            nav.querySelector('.nav__button').addEventListener('click', () => {
                t.resetNavs();
            });
        });
        
    }
    resetNavs() {
        let t = this;
        t.node.querySelector('.wrapper__content .content__basic').classList.add('active');
        t.node.querySelectorAll('.wrapper__content .content__nav').forEach( ( nav, index ) => {
            nav.classList.remove('active'); 
        });
    }
}
JSModules['MobileMenu'] = MobileMenu;
export default MobileMenu;